import { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { Navigate } from "react-router-dom";

// * Import Layouts
// import AdminLayout from "./Layouts/Admin.js";
import AuthLayout from "./Layouts/Auth.js";
import UserLayout from "./Layouts/User.js";

// * Import Views
import NotFound from "./Views/NotFound.js";
import Register from "./Views/Register.js";
import Login from "./Views/Login.js";

import Home from "./Views/Home.js";
import Profile from "./Views/Profile.js";
import Settings from "./Views/Settings.js";
import NewsFeed from "./Views/NewsFeed.js";
import TasksPage from "./Views/Tasks.js";
import LocationsPage from "./Views/Locations.js";
import People from "./Views/People.js";
import ShiftCalendar from "./Views/Schedule.js";
import Approve from "./Views/Approve.js";
import ReportsPage from "./Views/Reports.js";
import Test from "./Views/Test.js";
import AddNewLocation from "./Components/Location/AddNewLocation.js";
import EditLocation from "./Components/Location/EditLocation.js";
import { useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode";
import ExportDropdown from "./Components/Calendar/ExportDropdown.js";
import LocationManagementPage from "./Views/LocationManage.js";
import ReportPage from "./Views/Report1.js";

export default function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const now = new Date();

    // Convert to Ireland time components
    const irelandTimeParts = new Intl.DateTimeFormat("en-IE", {
      timeZone: "Europe/Dublin",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).formatToParts(now);

    // Extract parts
    const parts = {};
    irelandTimeParts.forEach(({ type, value }) => {
      parts[type] = value;
    });

    // Construct ISO string manually: YYYY-MM-DDTHH:mm:ss
    const irelandISOString = `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}.000Z`;

    dispatch({
      type: "SET_TIME",
      payload: irelandISOString,
    });
  }, []);

  useEffect(() => {
    let token = localStorage.getItem("token");
    if (token == null) {
      navigate("/login");
    } else {
      const decoded = jwtDecode(token);
      if (decoded.exp * 1000 < Date.now()) {
        localStorage.removeItem("token");
        navigate("/login");
      }
      dispatch({ type: "SET_USER", payload: decoded });
    }
  }, []);

  return (
    <Routes>
      {/* User routes: With header/footer/sidebar */}
      <Route element={<UserLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/user/profile" element={<Profile />} />
        <Route path="/user/settings" element={<Settings />} />
        <Route path="/newsfeed" element={<NewsFeed />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/people" element={<People />} />
        <Route path="/schedule" element={<ShiftCalendar />} />
        <Route path="/approve" element={<Approve />} />
        <Route path="/reports" element={<ReportPage />} />

        <Route path="/locations" element={<LocationsPage />} />
        <Route path="/locations/add" element={<AddNewLocation />} />
        <Route
          path="/locations/edit/:id"
          element={<LocationManagementPage />}
        />

        <Route path="/test_export" element={<ExportDropdown />} />
      </Route>

      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Route>

      {/* Catch-all route for 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
